import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import SubscibeToNewsletterCard from "../../cards/SubscibeToNewsletterCard";
import { GoPlus } from "react-icons/go";

const FooterWrapper = styled.footer`
  margin-bottom: 60px;
  margin-top: clamp(6rem, (100 / 1920) * 100vw, 6.25rem);
`;

const Container = styled.div`
  width: 80vw;
  background-color: #e8e8e8c9;
  padding: 80px 40px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  a:link,
  a:visited,
  a:active {
    text-decoration: none;
  }

  @media (max-width: 950px) {
    flex-direction: column;
    gap: 20px;
    width: 90vw;
    padding: 40px 20px;
  }
`;

const NewsletterWrapper = styled.div``;

const DesktopContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  align-items: start;
  margin: 0 auto;
  @media (max-width: 950px) {
    display: none;
  }
`;

const MobileAccordionWrapper = styled.div`
  display: none;

  @media (max-width: 950px) {
    display: block;
  }
`;

const FooterColumn = styled.div`
  ul {
    padding: 0;
    margin: 0;
  }

  li {
    list-style: none;
    cursor: pointer;
    margin: 12px 0;
    font-size: 12px;
  }

  a {
    color: ${colors.blackMuted}
  }

  span {
    color: #000000;
    font-size: 14px;
    font-weight: 500;
  }

  &:last-child {
    display: none;
  }
`;

const AccordionItem = styled.div`
  border-bottom: 1px solid ${colors.line};
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  font-size: ${fontSize.xs};
  text-transform: uppercase;
`;

const AccordionIcon = styled.div`
  svg {
    height: 18px;
    width: 18px;
    color: ${colors.black};
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? "rotate(45deg)" : "rotate(0deg)")};
  }
`;

const AccordionBody = styled.div`
  overflow: hidden;
  max-height: ${({ maxHeight }) => maxHeight}px;
  transition: max-height 0.4s ease;
  padding-left: 4px;

  ul {
    padding-left: 0;
    margin: 0;
  }

  li {
    margin-bottom: 16px;
    font-size: ${fontSize.xs};
  }
  a {
    color: #000000c6;
  }

  span {
    display: none;
  }
`;

function FooterMain() {
  const [openIndex, setOpenIndex] = useState(null);
  const accordionRefs = useRef([]);

  const footerSections = [
    {
      title: "SERVICE",
      content: (
        <ul>
          <span>SERVICE</span>
          <li>
            <a href="/contact">Contact Us</a>
          </li>
          <li>
            <a href="/contact">Customer Service</a>
          </li>
          <li>
            <a href="/faqs">Care Guide</a>
          </li>
          <li>
            <a href="/contact">Find Us</a>
          </li>
        </ul>
      ),
    },
    {
      title: "ORDERS",
      content: (
        <ul>
          <span>ORDERS</span>
          <li>
            <a href="/faqs">Payment</a>
          </li>
          <li>
            <a href="/faqs">Shipping</a>
          </li>
          <li>
            <a href="/faqs">Track Orders</a>
          </li>
          <li>
            <a href="/faqs">Returns & Exchanges</a>
          </li>
        </ul>
      ),
    },
    {
      title: "INITIATIVES",
      content: (
        <ul>
          <span>INITIATIVES</span>
          <li>
            <a href="#">Giving Back To The Mountains</a>
          </li>
        </ul>
      ),
    },
    {
      title: "FOLLOW US",
      content: (
        <ul>
          <li>
            <a
              href="https://www.instagram.com/peakpashmina?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </li>
          <li>
            <a href="#">Facebook</a>
          </li>
          <li>
            <a href="#">LinkedIn</a>
          </li>
          <li>
            <a href="#">Wechat</a>
          </li>
        </ul>
      ),
    },
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const getHeight = (index) => {
    if (!accordionRefs.current[index]) return 0;
    return accordionRefs.current[index].scrollHeight;
  };

  // Reset openIndex on resize to prevent mismatched heights
  useEffect(() => {
    const handleResize = () => setOpenIndex(null);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <FooterWrapper>
      <Container>
        <NewsletterWrapper>
          <SubscibeToNewsletterCard />
        </NewsletterWrapper>

        {/* Desktop Columns */}
        <DesktopContainer>
          {footerSections.map((section, idx) => (
            <FooterColumn key={idx}>{section.content}</FooterColumn>
          ))}
        </DesktopContainer>

        {/* Mobile Accordion */}
        <MobileAccordionWrapper>
          {footerSections.map((section, idx) => (
            <AccordionItem key={idx}>
              <AccordionHeader onClick={() => toggleAccordion(idx)}>
                <span>{section.title}</span>
                <AccordionIcon isOpen={openIndex === idx}>
                  <GoPlus />
                </AccordionIcon>
              </AccordionHeader>
              <AccordionBody
                maxHeight={openIndex === idx ? getHeight(idx) : 0}
                ref={(el) => (accordionRefs.current[idx] = el)}
              >
                {section.content}
              </AccordionBody>
            </AccordionItem>
          ))}
        </MobileAccordionWrapper>
      </Container>
    </FooterWrapper>
  );
}

export default FooterMain;
